"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
function bindWith(source) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var proto = Reflect.getPrototypeOf(source);
    var bindMethod = function (cur, key) {
        var _a;
        var f = source[key];
        if (typeof (f) === 'function') {
            return __assign(__assign({}, cur), (_a = {}, _a[key] = f.bind.apply(f, __spread([source], args)), _a));
        }
        return cur;
    };
    var methods = Object.keys(proto || []).reduce(bindMethod, {});
    return __assign(__assign({}, methods), Object.keys(source).reduce(bindMethod, {}));
}
exports.default = bindWith;
//# sourceMappingURL=bindWith.js.map